// loaded products
function loadedProducts() {
  const loadedProducts = document.getElementById("loaded-products");
  const products = product_grid.getElementsByClassName("grid-item");
  loadedProducts.innerText = products.length;
}

function loadMoreProducts() {
  load_more_btn.style.display = "none";
  load_more_spinner.style.display = "block";
  getNextPage().then((nextPage) => {
    console.log(nextPage);

    const parser = new DOMParser();
    const nextPageDoc = parser.parseFromString(nextPage, "text/html");

    load_more_spinner.style.display = "none";

    const productgrid = nextPageDoc.getElementById("product-grid");
    const new_products = productgrid.getElementsByClassName("grid-item");
    const new_url = nextPageDoc.getElementById("product-grid-paginate").dataset
      .nextUrl;
    if (new_url) {
      load_more_btn.style.display = "block";
    } else {
      load_more_btn_wrapper.style.display = "none";
    }

    next_url = new_url;
    for (let i = 0; i < new_products.length; i++) {
      product_grid.appendChild(new_products[i]);
    }

    loadedProducts();
  });
}

const url_data = document.getElementById("product-grid-paginate");
const product_grid = document.getElementById("product-grid");
let next_url = url_data.dataset.nextUrl;

const load_more_btn_wrapper = document.getElementsByClassName("load-more")[0];

const load_more_btn = document.getElementsByClassName("load-more_btn")[0];
const load_more_spinner =
  document.getElementsByClassName("load-more_spinner")[0];

async function getNextPage() {
  const response = await fetch(next_url)
    .then((response) => response.text())
    .catch((err) => console.log(err));
  return response;
}

loadedProducts();

// Add a click event listener to the "Load More" button
load_more_btn.addEventListener("click", loadMoreProducts);
